export function PopoverHtmlUnsafe($tooltip) {
  'ngInject';

  return $tooltip('popoverHtmlUnsafe', 'popover', 'click');
}

export function PopoverHtmlUnsafePopup() {
  'ngInject';

  return {
    restrict: 'EA',
    replace: true,
    scope: {
      title: '@',
      content: '@',
      placement: '@',
      animation: '&',
      isOpen: '&'
    },
    templateUrl: require('./popoverHtmlUnsafePopup.html')
  };
}
